import { useEffect, useState } from 'react';
import {
  clearServiceWorkerRegistrations,
  clearCacheStorage,
} from '@/services/pwaRegistrationService';

export function RefreshPage() {
  const [status, setStatus] = useState('Clearing cache...');

  useEffect(() => {
    const refresh = async () => {
      try {
        await clearServiceWorkerRegistrations();
        await clearCacheStorage();
        sessionStorage.clear();
        localStorage.clear();
        setStatus('Redirecting...');
        window.location.href = '/';
      } catch {
        setStatus('Failed to clear cache. Please try again.');
      }
    };

    void refresh();
  }, []);

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-primary-600" />
        <p className="text-gray-600">{status}</p>
      </div>
    </div>
  );
}
